import { render } from "./Sideli.vue?vue&type=template&id=04c22018&scoped=true"
import script from "./Sideli.vue?vue&type=script&lang=js"
export * from "./Sideli.vue?vue&type=script&lang=js"

import "./Sideli.vue?vue&type=style&index=0&id=04c22018&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c22018"]])

export default __exports__